"use client";
import type { ReactNode } from "react";

export function BlogCta({ slug, href, children }: { slug: string; href: string; children: ReactNode }) {
  function trackClick() {
    const analytics = window as Window & { gtag?: (command: string, name: string, parameters: Record<string, string>) => void };
    analytics.gtag?.("event", "blog_cta_click", { article_slug: slug, cta_destination: href, transport_type: "beacon" });
    window.clarity?.("set", "article_slug", slug);
    window.clarity?.("event", "blog_cta_click");
  }
  return <a href={href} onClick={trackClick} className="inline-block rounded-full bg-[#2B1B1C] px-6 py-3 text-white" data-blog-cta={slug}>{children}</a>;
}
